// Syncs the range input value to the --position custom property that clips the before image.
class SComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const input = this.querySelector('[data-comparison-input]');
    if (!input) return;
    const update = () => {
      this.style.setProperty('--position', `${input.value}%`);
    };
    input.addEventListener('input', update, { signal: this.controller.signal });
    update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('s-comparison-slider')) {
  customElements.define('s-comparison-slider', SComparisonSlider);
}
